import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { AgreementContainerV2 } from './containers/AgreementContainerV2';
import { HelpContainer } from '../HelpContainer';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var AgreementView = function AgreementView() {
  return /*#__PURE__*/_jsx(ViewContainer, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AgreementContainerV2, {}), /*#__PURE__*/_jsx(HelpContainer, {})]
    })
  });
};